import React from 'react';
import { useDarkMode } from '../darkmode/DarkModeContext';

const Benefits = () => {
  const { isDarkMode } = useDarkMode();

  // Perbaikan styling untuk dark mode
  const cardStyle = isDarkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-900';
  const textStyle = isDarkMode ? 'text-gray-300' : 'text-gray-600';
  const headingStyle = isDarkMode ? 'text-white' : 'text-gray-900';
  // const backgroundStyle = isDarkMode ? '#111827' : '#f3f4f6';

  return (
    <section
      className={`py-16 ${isDarkMode ? 'bg-gray-900' : 'bg-gray-100'}`}
      style={{
        backgroundImage: "url('https://telnet.net.id/assets/bg.png')",
        backgroundColor: isDarkMode ? '#111827' : '#dfe4e0ff',
        backgroundBlendMode: 'overlay',
      }}
    >
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className={`text-4xl font-bold mb-4 ${headingStyle}`}>
            Keunggulan TV & IPTV Kami
          </h2>
          <p className={`text-xl ${textStyle} max-w-3xl mx-auto`}>
            Teknologi streaming terdepan dengan fitur-fitur canggih untuk pengalaman menonton yang tak terlupakan
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* 4K Ultra HD */}
          <div className={`rounded-2xl p-6 text-center hover:transform hover:scale-105 transition-all duration-300 shadow-lg ${cardStyle}`}>
            <div className="flex justify-center mb-4">
              <img
                src="/image/produk TV/Ultra HD.png"
                alt="4K Icon"
                className="w-15 h-15 object-contain"
              />
            </div>
            <h3 className={`text-xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
              4K Ultra HD
            </h3>
            <p className={textStyle}>
              Nikmati kualitas video terbaik dengan resolusi 4K Ultra HD. Detail yang tajam dan warna yang hidup.
            </p>
          </div>

          {/* Multi-Device Access */}
          <div className={`rounded-2xl p-6 text-center hover:transform hover:scale-105 transition-all duration-300 shadow-lg ${cardStyle}`}>
            <div className="flex justify-center mb-4">
              <img
                src="/image/produk TV/multi_device.png"
                alt="Multi-Device Icon"
                className="w-15 h-15 object-contain"
              />
            </div>
            <h3 className={`text-xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
              Multi-Device Access
            </h3>
            <p className={textStyle}>
              Tonton di TV, smartphone, tablet, atau laptop. Sinkronisasi otomatis di semua perangkat Anda.
            </p>
          </div>

          {/* Cloud DVR */}
          <div className={`rounded-2xl p-6 text-center hover:transform hover:scale-105 transition-all duration-300 shadow-lg ${cardStyle}`}>
            <div className="flex justify-center mb-4">
              <img
                src="/image/produk TV/cloud.png"
                alt="Cloud DVR Icon"
                className="w-15 h-15 object-contain"
              />
            </div>
            <h3 className={`text-xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
              Cloud DVR
            </h3>
            <p className={textStyle}>
              Rekam acara favorit ke cloud storage. Tonton kapan saja tanpa khawatir storage penuh.
            </p>
          </div>

          {/* Catch-up TV */}
          <div className={`rounded-2xl p-6 text-center hover:transform hover:scale-105 transition-all duration-300 shadow-lg ${cardStyle}`}>
            <div className="flex justify-center mb-4">
              <img
                src="/image/produk TV/IPTV.png"
                alt="Catch-up TV Icon"
                className="w-15 h-15 object-contain"
              />
            </div>
            <h3 className={`text-xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
              Catch-up TV
            </h3>
            <p className={textStyle}>
              Lewat acara favorit? Tonton kembali hingga 30 hari terakhir dengan fitur catch-up TV.
            </p>
          </div>

          {/* Parental Control */}
          <div className={`rounded-2xl p-6 text-center hover:transform hover:scale-105 transition-all duration-300 shadow-lg ${cardStyle}`}>
            <div className="flex justify-center mb-4">
              <img
                src="/image/produk TV/Parental Control.png"
                alt="Parental Control Icon"
                className="w-15 h-15 object-contain"
              />
            </div>
            <h3 className={`text-xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
              Parental Control
            </h3>
            <p className={textStyle}>
              Kontrol penuh untuk orang tua. Filter konten, atur waktu menonton, dan blokir saluran tertentu.
            </p>
          </div>

          {/* Premium Channels */}
          <div className={`rounded-2xl p-6 text-center hover:transform hover:scale-105 transition-all duration-300 shadow-lg ${cardStyle}`}>
            <div className="flex justify-center mb-4">
              <img
                src="/image/produk TV/premium.png"
                alt="Premium Channels Icon"
                className="w-15 h-15 object-contain"
              />
            </div>
            <h3 className={`text-xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
              Premium Channels
            </h3>
            <p className={textStyle}>
              Akses saluran premium seperti HBO, Showtime, Fox Sports, dan banyak lagi dalam satu paket.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;